import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { MobileBottomNav } from './MobileBottomNav';
import { Sidebar } from './Sidebar';

export function Layout() {
  return (
    <div className="flex min-h-dvh min-w-0 overflow-x-hidden bg-background">
      <Sidebar />
      {/* min-w-0 lets this flex child shrink to fit the viewport instead of
          being pushed wider by an oversized descendant (e.g. the timeline
          grid's minmax day columns when many days are loaded — issue #12). */}
      <div className="flex min-w-0 flex-1 flex-col pb-[calc(4rem+env(safe-area-inset-bottom))] lg:pb-0 lg:pl-64">
        <Header />
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
      <MobileBottomNav />
    </div>
  );
}
